// extracted by mini-css-extract-plugin
module.exports = {"accordion":"FAQListing-styles-module--accordion--I1M7t","item":"FAQListing-styles-module--item--25tno"};